import { render, staticRenderFns } from "./message-audio.vue?vue&type=template&id=21f461ee&scoped=true"
import script from "./message-audio.vue?vue&type=script&lang=ts"
export * from "./message-audio.vue?vue&type=script&lang=ts"
import style0 from "./message-audio.vue?vue&type=style&index=0&id=21f461ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f461ee",
  null
  
)

export default component.exports